import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { authQueryOptions } from "~/lib/auth/queries";

const guestSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/_guest")({
  validateSearch: guestSearchSchema,
  component: RouteComponent,
  beforeLoad: async ({ context, search }) => {
    const DEFAULT_REDIRECT = "/dashboard";
    const redirectUrl = search.redirect || DEFAULT_REDIRECT;

    const user = await context.queryClient.ensureQueryData({
      ...authQueryOptions(),
      revalidateIfStale: true,
    });
    if (user) {
      throw redirect({
        to: redirectUrl,
      });
    }

    return {
      redirectUrl,
    };
  },
});

function RouteComponent() {
  return (
    <div className="bg-background flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <Outlet />
      </div>
    </div>
  );
}
